module.exports = __webpack_public_path__ + "src/assets/zh.5397c4c3.png";